import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { NavBar, Login, ResetPassword, ChangePassword } from './components';
import {
  FotosClub, Contacto, Calendario, QuienesSomos, ReservaSalas,
  Inicio, Registro, GestionSolicitudes
} from './pages';
import './styles/global.css';


function App() {
  return (
    <AuthProvider>
      <Router>
        <NavBar />
        <Routes>
          <Route path="/" element={<Inicio />} />
          <Route path="/fotos" element={<FotosClub />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="/calendario" element={<Calendario />} />
          <Route path="/quienes-somos" element={<QuienesSomos />} />
          <Route path="/reserva-salas" element={<ReservaSalas />} />
          <Route path="/login" element={<Login />} />
          <Route path="/registro" element={<Registro />} />
          <Route path="/gestion-solicitudes" element={<GestionSolicitudes />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/change-password" element={<ChangePassword />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;